import React,{useEffect,useState} from 'react';
import ListItemERA from '../components/ListItemERA.js';
import { BrowserRouter as Router,Routes, Route, Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import {allStates} from '../components/Helper';
import '../App.css';


const EmergencyRentalAssistance=()=>{

let { state } = useParams();
const [data, setData] = useState(null);
const [foundState, setFoundState] = useState([]);

const dataFetch = async () => {

  if(typeof state === 'undefined'){
    state='';
  }
  fetch('https://api.hudhousingnetwork.com/emergency-rental-assistance?state='+state)
        .then(response => response.json())
        .then((data) =>{ 
            setData(data);
          //console.log(data)
          }
        );

};

const stateFetch = async () => {

  if(typeof state === 'undefined'){
    return;
  }
  fetch('https://api.hudhousingnetwork.com/get/'+state)
        .then(response => response.json())
        .then((data) =>{ 
          if(data.length>0)
          setFoundState(data[0].state);
          //console.log("R: "+data[0].state);
          }
        );

};

useEffect(()=>{
 console.log('Loaded!'); 
 stateFetch();
 dataFetch();

},[])

const setClick=(val)=>{
  var url='/emergency-rental-assistance/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

  return (

<>
  <Header />
  <div className="content_wrapper">
    <div className="main-content">
      <h2 className="top-heading">Emergency Rental Assistance  {foundState!="" ? 'for '+foundState : ''}</h2>

      <select className="statesDD" onChange={(e)=>setClick(e.target.value)} >
      {
          allStates.map((postData,index) => {            
            var selected = postData['state_code'].toLowerCase()==state ? 'selected' : '';
            return (<option key={index} selected={selected} value={postData['state_code'].toLowerCase()}>{postData['state']}</option>)
          
        })
      }        
      </select><br />

      {data!=null && (

          data.map((item,index) => (
            <ListItemERA key={index} item={item} />
          ))    

      )
      }

      {data!=null && data.length==0 && (
      <span className="sorry">Sorry we are unable to find any matching records!</span>)
      }

    </div>
    <div className="sidebar">
      <div className="side-box">
        <img src="/img/apt1.png" />
        <div className="side-box-content">
          <h3>Spring View Apartments</h3>
          <p>Read our getting started guide</p>
          <div className="side-box-flex">
            <h4>Section 8 Apartment</h4>
            <a className="applyLink" href="/">Apply</a>
          </div>  
        </div>
      </div>
      <div className="side-box">
        <img src="/img/apt2.png" />
        <div className="side-box-content">
          <h3>Spring View Apartments</h3>
          <p>Read our getting started guide</p>
          <div className="side-box-flex">
            <h4>Section 8 Apartment</h4>
            <a className="applyLink" href="/">Apply</a>  
          </div>  
        </div>
      </div>
      <div className="side-box">
        <img src="/img/apt1.png" />
        <div className="side-box-content">
          <h3>Spring View Apartments</h3>
          <p>Read our getting started guide</p>
          <div className="side-box-flex">
            <h4>Section 8 Apartment</h4>
            <a className="applyLink" href="/">Apply</a>  
          </div>  
        </div>
      </div>
      <div className="side-box">
        <img src="/img/apt2.png" />
        <div className="side-box-content">
          <h3>Spring View Apartments</h3>
          <p>Read our getting started guide</p>
          <div className="side-box-flex">
            <h4>Section 8 Apartment</h4>
            <a className="applyLink" href="/">Apply</a>  
          </div>  
        </div>
      </div>
    </div>
  </div>
  <div className="content_wrapper">
    <div className="side-box">
      <img src="/img/apt1.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" alt="" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
  </div>
  <div className="content_wrapper">
    <div className="bottom-box">
      <div className="bottom-box-flex">
        <div className="bottom-box-image"><img src="/img/Housing-authority.png" /></div>
        <div className="bottom-box-content">
          <h2>Housing-authority</h2>
          <p>1243 West Sycamore Lafayette GA, 29010</p>
        </div>
      </div>
      <div className="bottom-box-flex2">
        <a href="" className="contact-us-link">Contact Us</a>
        <div className="bottom-box-icon">
          <img src="/img/Group238491.png" />
          <img src="/img/Group238493.png" />
        </div>
      </div>
    </div>  
  </div>








</>
  );
}

export default EmergencyRentalAssistance;
